import { useState, useEffect, useRef } from 'react';

import etiqueta from '../../../images/ayuda/etiqueta.svg';
import telefono from '../../../images/ayuda/icon_phone.svg';
import whatsapp from '../../../images/ayuda/icon_whatsapp.svg';
import messenger from '../../../images/ayuda/icon_messenger.svg';
import faqs from '../../../images/ayuda/icon_faqs.svg';
import arrow from '../../../images/ayuda/arrow.svg';
import s from '../../../images/ayuda/s.svg';

function HeroAyuda() {

    const [show,setShow]= useState(false);

    return (

    <section className="HeroAyuda">
        <div className="wrap">
            <img src={etiqueta} className="etiqueta" />
            <h1 className="titles">Hola! En qué podemos <br /> ayudarte? </h1>
            <p>¡No te quedes con dudas! Estamos a disposición para lo que necesites.</p>


            <ul className="AyudaBoxes">
                <li>
                    <button onClick={()=>setShow(!show)} className="AyudaBoxes__box sinbox">
                        <span>
                            <figure>
                                <img src={telefono} />
                            </figure>
                            <h4>Llámanos</h4>
                        </span>
                    </button>

                    {
                        show?
                        <button onClick={()=>setShow(!show)} className="AyudaBoxes__box openBox">
                            <img src={arrow} className="arrow" />
                            <p>Ponte en contacto con nuestro personal, <br /> siempre dispuesto a <br />ayudarte 😃.</p>
                            <p className="highlight">Contact Center <br />(591-3) 363-5555</p>
                        </button>
                        :null
                    }

                </li>
                <li>
                    <a href="https://wa.me/5492235210681" target="blank" className="AyudaBoxes__box sinbox toWhatsapp">
                        <span>
                            <figure>
                                <img src={whatsapp} />
                            </figure>
                            <h4>Whatsapp</h4>
                        </span>
                    </a>
                </li>
                <li>
                    <a href="https://facebook.com"  target="blank" className="AyudaBoxes__box sinbox toMessenger">
                        <span>
                            <figure>
                                <img src={messenger} />
                            </figure>
                            <h4>Facebook Messenger</h4>
                        </span>
                    </a>
                </li>
                <li>
                    <a href="/ayuda#faqs" className="AyudaBoxes__box sinbox toFaqs">
                        <span>
                            <figure>
                                <img src={faqs} />
                            </figure>
                            <h4>Preguntas frecuentes</h4>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
        <img src={s} className="s" />
    </section>

  )
}

export default HeroAyuda
